/**
 * API middleware for logging result of individual requests
 *
 * This should be after [RetryMiddleware]{@link module:API.RetryMiddleware} so
 * that all retried requests are logged individually.
 *
 * This adds support for a `suppressLogging` option on the request to disable
 * logging.
 *
 * @memberof module:API
 */
class RequestLoggingMiddleware {
  // TODO: Log this stuff is a *useful* way, write tests when you do
  constructor({ logger }) {
    this.logger = logger;
  }

  // No jsdoc
  handler = async (url, options, next) => {
    if (options.suppressLogging) {
      return next(url, options);
    }

    const startTime = Date.now();

    try {
      const result = await next(url, options);

      this.logger.logBlock('Request successful', (logger) => {
        logger.log('url:', url);
        logger.log('runTime:', Date.now() - startTime);
        logger.log('retriesRemaining:', options.retriesRemaining);
      });

      return result;
    } catch (err) {
      this.logger.logBlock('Request failed', (logger) => {
        logger.log('url:', url);
        logger.log('runTime:', Date.now() - startTime);
        logger.log('retriesRemaining:', options.retriesRemaining);
        logger.log('fatal:', err.xtv.fatal);
      });

      throw err;
    }
  }
}

export default RequestLoggingMiddleware;
